import {Card, Row} from 'antd';
import {useNavigate} from "react-router";

export const ReportMenu = ({refresh, onRefresh, onApiFail}) => {
    const navigate = useNavigate();

    const onHarvestClick = () => {
        navigate('/report/harvest');
    }

    const onBatchClick = () => {
        navigate('/report/batch');
    }

    return <div style={{backgroundColor: "#8f8f8f"}}>
        <Row>
            <Card size="small" title="Batch Harvest Report" variant={"borderless"} style={{margin: 16, width: 300, cursor: 'pointer'}} onClick={onHarvestClick}>
                <ul style={{textAlign: 'left'}}>
                    <li>Compile a report for a Batch</li>
                    <li>List all raw wholesale products harvested from a batch.</li>
                </ul>
            </Card>
            <Card size="small" title="Batch Sales Report" variant={"borderless"} style={{margin: 16, width: 300, cursor: 'pointer'}} onClick={onBatchClick}>
                <ul style={{textAlign: 'left'}}>
                    <li>Compile a Sales Report for a Batch</li>
                    <li>List all products sold for a Batch</li>
                </ul>
            </Card>
            <Card size="small" title="Next Report" variant={"borderless"} style={{margin: 16, width: 300}}>
                <ul style={{textAlign: 'left'}}>
                    <li>Future implementation</li>
                </ul>
            </Card>
        </Row>

    </div>
}